import tabNavigation from "./palmares";

document.addEventListener("DOMContentLoaded", function () {
  tabNavigation();
});
